import { useContext } from "react";
import { Container } from "react-grid-system";
import { useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  DuotoneIcon,
  Heading,
  Icon,
  Span,
} from "@icg360/design-system";

import { EmailIconLink, MSSLink, PhoneIconLink } from "components/common/link";
import { Stack } from "components/common/stack";
import { AuthAppContext } from "components/root/auth-app-provider";

import styles from "./ineligible-offer.module.scss";

export const IneligibleOffer = () => {
  const navigate = useNavigate();
  const { policies, userInsuranceRep } = useContext(AuthAppContext);
  const hasMultiplePolicies = (policies?.length ?? 0) > 1;
  if (!userInsuranceRep) {
    return null;
  }

  const {
    agencyName,
    agentStreetNumber,
    agentStreetName,
    agentZipCode,
    agentCity,
    agentState,
    agentEmail,
    agentPhone: unFormattedPhone = "",
  } = userInsuranceRep;

  return (
    <Container>
      <div className={styles.backButtonWrapper}>
        <Button
          size="sm"
          leadingIcon="Back"
          appearance="tertiary"
          onPress={() => navigate("/my/overview")}
        >
          Back
        </Button>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.headerIcon}>
            <DuotoneIcon name="NoData" size="lg" />
          </div>
          <Stack gap="sm">
            <Heading size="md">This policy is not eligible</Heading>
            <Span color="quiet">
              {hasMultiplePolicies ? (
                <>
                  <MSSLink to="/my/settings/property-services">
                    View other policies
                  </MSSLink>{" "}
                  and check eligibility.{" "}
                </>
              ) : (
                ""
              )}
              For more questions, contact your insurance representative.
            </Span>
          </Stack>
          <Card className={styles.repCard} border>
            <Span className={styles.repCardIconDS}>
              <Icon name="HouseTalk" size="xl" />
            </Span>
            <div className={styles.repCardContent}>
              <div>
                <Span bold>{agencyName}</Span>
                <Span color="quiet">
                  {/* agent possibly missing street address */}
                  {agentStreetNumber && agentStreetName && (
                    <div>{`${agentStreetNumber} ${agentStreetName}`}</div>
                  )}
                  <div>{`${agentCity}, ${agentState} ${agentZipCode}`}</div>
                </Span>
              </div>
              {agentEmail ? <EmailIconLink email={agentEmail} /> : null}
              {unFormattedPhone ? (
                <PhoneIconLink phone={unFormattedPhone} />
              ) : null}
            </div>
          </Card>
        </div>
      </div>
    </Container>
  );
};
